var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-08-30
 * @brief EHP ManageMent - SiteManageMent 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import { useAsync } from "react-async";
// recoil && state
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//utils
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import EhpPagination from "../../common/pagination/EhpPagination";
import { useNavigate } from "react-router-dom";
import EhpPostCode from "../../common/postcode/EhpPostCode";
//
/**
 * @brief EHP ManageMent - ApprovalManageMent 개발 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function SiteApprovalManageMent(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const setParentPopWin = props.setPopWin;
    //
    const [treeDto, setTreeDto] = useState([]);
    const [toggle, setToggle] = useState(false);
    const [item, setItem] = useState(null);
    //
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [siteAddress, setSiteAddress] = useState("");
    function callbackSetSubZoneInfoAddress(val) {
        setSiteAddress(val);
    }
    let appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    // 사업장 승인 요청 List
    const { data: data, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/usertree/zoneapprovallist?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath
    });
    useEffect(() => {
        // error page 이동
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setTreeDto(data.body);
                setPageInfo(data.data.page);
            }
        }
    }, [data]);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function toggles(e) {
        if (toggle === false) {
            setToggle(true);
        }
        else {
            setToggle(false);
        }
    }
    //사업장 승인 요청 API - pop List
    function sitePop(e, list) {
        setItem(list);
        CUTIL.jsopen_Popup(e);
    }
    useEffect(() => {
        setParentPopWin("pop-workplace-ok", (item) && React.createElement(SiteApprovalPop, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD"), item: item, onClickPostCode: onClickPostCode, siteAddress: siteAddress, setSiteAddress: setSiteAddress }));
    });
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    useEffect(() => {
        setParentPopWin("pop-postcode", React.createElement(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetSubZoneInfoAddress }));
    });
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_Popup(e);
    }
    const treeList = (treeDto === null) ? null : treeDto;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "page-top more__detail", onClick: (e) => toggles(e) },
            React.createElement("h2", null, "\uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD"),
            React.createElement("p", { className: "user-num" }, pageInfo.totalElements)),
        React.createElement("div", { className: `area__right_content detail__view  ${(toggle) ? "on" : ""}` },
            React.createElement("div", { className: "tbl-list hcal-vh-315" },
                React.createElement("table", { summary: "\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uD68C\uC0AC, \uC0AC\uC5C5\uC7A5,\uC774\uB984, \uD5C8\uC6A9 \uC694\uCCAD \uD68C\uC0AC,\uD5C8\uC6A9 \uC694\uCCAD \uC0AC\uC5C5\uC7A5 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: " txt-left js-open", "data-pop": "pop-user-type" },
                                React.createElement("span", null, "\uC0AC\uC6A9\uC790 \uD0C0\uC785")),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC"),
                            React.createElement("th", { scope: "col", className: "txt-left d-sm-none" }, "\uC0AC\uC5C5\uC7A5"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                            React.createElement("th", { scope: "col", className: "txt-left d-sm-none" }, "\uD5C8\uC6A9 \uC694\uCCAD \uD68C\uC0AC"),
                            React.createElement("th", { scope: "col", className: "txt-left pl-50 d-sm-none" }, "\uD5C8\uC6A9 \uC694\uCCAD \uC0AC\uC5C5\uC7A5"),
                            React.createElement("th", { scope: "col" }, "\uC2B9\uC778\uC694\uCCAD"))),
                    React.createElement("tbody", null, treeList.map((list) => (React.createElement("tr", { key: list.id },
                        React.createElement("td", { className: "txt-left" }, (list.user.role === "ROLE_ADMIN") ? "Admin" : (list.user.role === "ROLE_ENGINEER") ? "Engineer" : (list.user.role === "ROLE_USER") ? "User" : ""),
                        React.createElement("td", { className: "txt-left" }, list.user.userCompany),
                        React.createElement("td", { className: "txt-left d-sm-none" },
                            React.createElement("p", { className: "ellipsis" }, list.user.userZone)),
                        React.createElement("td", { className: "txt-left" }, list.user.userName),
                        React.createElement("td", { className: "txt-left d-sm-none" },
                            React.createElement("p", { className: "ellipsis" }, list.company.companyName)),
                        React.createElement("td", { className: `txt-new txt-left pl-50 d-sm-none ${(list.zone.approval == 1) ? " icon-new" : ""}` },
                            React.createElement("p", { className: "ellipsis" },
                                React.createElement("span", null, list.zone.zoneName))),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "bg-blue center js-open", "data-pop": "pop-workplace-ok", onClick: (e) => sitePop(e, list) },
                                React.createElement("span", { "data-pop": "pop-workplace-ok" }, "\uD655\uC778"))))))))),
            (pageInfo) && React.createElement(EhpPagination, { componentName: "StieApproval", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default SiteApprovalManageMent;
function SiteApprovalPop(props) {
    //recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    // props
    const item = props.item;
    const onClickPostCode = props.onClickPostCode;
    const siteAddress = props.siteAddress;
    const setSiteAddress = props.setSiteAddress;
    //
    const [list, setList] = useState(null);
    const [siteZoneName, setSiteZoneName] = useState("");
    const [siteMemo, setSiteMemo] = useState("");
    const [companionTxt, setCompanionTxt] = useState("");
    const [sitePutDisplay, setSitePutDisplay] = useState(false);
    const [siteDisplayDone, setSiteDisplayDone] = useState(false);
    const [siteDisplayCompanion, setSiteDisplayCompanion] = useState(false);
    const [update, setUpdate] = useState(false);
    // 상세 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/usertree/${item.id}/detail`,
        userToken: userInfo.loginInfo.token,
        watch: item.id + update
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setList(data.body);
                setSiteZoneName(data.body.zone.zoneName);
                setSiteAddress(data.body.zone.address);
                setSiteMemo(data.body.zone.memo);
                setUpdate(false);
            }
        }
    }, [data]);
    //site update dispaly envet
    function sitePut(e) {
        if (sitePutDisplay === false) {
            setSitePutDisplay(true);
            setCompanionTxt("");
            setSiteDisplayDone(false);
        }
    }
    // site PUT API
    function siteUpdate(e, list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/api/v2/product/company/zone/${list.zone.zoneId}/usertree/${list.id}`,
                appQuery: {
                    companyId: list.company.companyId,
                    zoneName: siteZoneName,
                    address: siteAddress,
                    memo: siteMemo
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSitePutDisplay(false);
                    setUpdate(true);
                }
            }
        });
    }
    // 반려 선택
    function onCompanion(e) {
        if (siteDisplayCompanion === false) {
            setSiteDisplayCompanion(true);
            setSiteDisplayDone(false);
        }
    }
    // 승인 선택
    function onDone(e) {
        if (siteDisplayDone === false) {
            setSiteDisplayDone(true);
            setSiteDisplayCompanion(false);
            setCompanionTxt("");
        }
    }
    //승인 - 완료
    function siteDone(e, list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/api/v2/product/usertree/user/${list.user.userIdPk}`,
                appQuery: {
                    product: "zone",
                    productName: list.zone.zoneName,
                    productParentId: list.company.companyId,
                    approval: 2,
                    isontree: true
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("사업장 승인 요청이 완료 되었습니다.");
                    window.location.reload();
                }
            }
        });
    }
    // 반려 - 완료
    function siteCompanion(e, list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/api/v2/product/usertree/user/${list.user.userIdPk}`,
                appQuery: {
                    product: "zone",
                    productName: list.zone.zoneName,
                    productParentId: list.company.companyId,
                    approval: 0,
                    deniedReason: companionTxt,
                    isontree: true
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    alert("반려 요청이 완료되었습니다.");
                    window.location.reload();
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        (list) &&
            React.createElement("div", { className: "popup__body" },
                React.createElement("div", { className: "tbl-list type2 mt-16 " },
                    React.createElement("table", { summary: "\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uD68C\uC0AC,\uC774\uB984,E-mail(ID),\uC5F0\uB77D\uCC98 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD\uC790 \uC815\uBCF4 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD\uC790 \uC815\uBCF4 \uBAA9\uB85D"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", { className: "d-sm-none" },
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC6A9\uC790 \uD0C0\uC785"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "E-mail(ID)"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5F0\uB77D\uCC98"))),
                        React.createElement("tbody", { className: "d-sm-none" },
                            React.createElement("tr", null,
                                React.createElement("td", { className: "txt-left" }, (list.user.role === "ROLE_ADMIN") ? "Admin" : (list.user.role === "ROLE_ENGINEER") ? "Engineer" : (list.user.role === "ROLE_USER") ? "User" : ""),
                                React.createElement("td", { className: "txt-left" }, list.user.userCompany),
                                React.createElement("td", { className: "txt-left" }, list.user.userName),
                                React.createElement("td", { className: "txt-left" }, list.user.userId),
                                React.createElement("td", { className: "txt-left" }, list.user.phoneNumber))),
                        React.createElement("tbody", { className: "d-sm-block" },
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uC0AC\uC6A9\uC790 \uD0C0\uC785"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uD68C\uC0AC"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984")),
                            React.createElement("tr", null,
                                React.createElement("td", { className: "txt-left" }, (list.user.role === "ROLE_ADMIN") ? "Admin" : (list.user.role === "ROLE_ENGINEER") ? "Engineer" : (list.user.role === "ROLE_USER") ? "User" : ""),
                                React.createElement("td", { className: "txt-left" }, list.user.userCompany),
                                React.createElement("td", { className: "txt-left" }, list.user.userName)),
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", colSpan: 2, className: "txt-left" }, "E-mail(ID)"),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5F0\uB77D\uCC98")),
                            React.createElement("tr", null,
                                React.createElement("td", { className: "txt-left", colSpan: 2 }, list.user.userId),
                                React.createElement("td", { className: "txt-left" }, list.user.phoneNumber))))),
                React.createElement("div", { className: "workplace__info" },
                    React.createElement("div", { className: "img_workplace" }, (list.zone.image)
                        ? React.createElement("img", { src: list.zone.image.url, alt: list.zone.image.name })
                        :
                            React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" })),
                    React.createElement("div", { className: "txt_workplace" },
                        React.createElement("div", { className: "page-top" },
                            React.createElement("h2", null, list.company.companyName + " " + list.zone.zoneName),
                            React.createElement("div", { className: "top-button" }, (list.zone.approval == 1) &&
                                React.createElement("button", { type: "button", className: `btn-edit ${(props.sitePutDisplay) ? "active" : ""}`, onClick: (e) => sitePut(e) },
                                    React.createElement("span", { className: "hide" }, "\uC218\uC815")))),
                        (sitePutDisplay) &&
                            React.createElement("ul", { className: "form__input" },
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "text", id: "inp1", disabled: true, value: list.company.companyName }))),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "text", id: "inp2", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: siteZoneName, onChange: (e) => setSiteZoneName(e.target.value) }))),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("div", { className: "box__search" },
                                            React.createElement("input", { type: "text", className: "h40", placeholder: "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694", value: siteAddress, disabled: true }),
                                            React.createElement("button", { type: "button", className: "btn btn-search", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) },
                                                React.createElement("span", { className: "hide" }, "\uC870\uD68C"))))),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("textarea", { className: "h66", placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694", value: siteMemo, onChange: (e) => setSiteMemo(e.target.value) }))),
                                React.createElement("li", null,
                                    React.createElement("div", { className: "btn__wrap right w100p" },
                                        React.createElement("button", { type: "button", onClick: (e) => siteUpdate(e, list) },
                                            React.createElement("span", null, "\uC800\uC7A5"))))),
                        (!sitePutDisplay) &&
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                                    React.createElement("p", { className: "txt" }, list.company.companyName)),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                                    React.createElement("p", { className: "txt" }, list.zone.zoneName)),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                                    React.createElement("p", { className: "txt" }, list.zone.address)),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                    React.createElement("p", { className: "txt h82" }, list.zone.memo)),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit star mt-8" }, "\uC2B9\uC778 \uC5EC\uBD80"),
                                    React.createElement("div", { className: "btn__wrap" },
                                        React.createElement("button", { type: "button", className: (siteDisplayDone) ? "bg-navy" : "", onClick: (e) => onDone(e) },
                                            React.createElement("span", null, "\uC2B9\uC778")),
                                        React.createElement("button", { type: "button", className: (siteDisplayCompanion) ? "bg-navy" : "", onClick: (e) => onCompanion(e) },
                                            React.createElement("span", null, "\uBC18\uB824")))),
                                (siteDisplayCompanion) &&
                                    React.createElement("li", null,
                                        React.createElement("p", { className: "tit star" }, "\uBC18\uB824 \uC0AC\uC720 \uC785\uB825"),
                                        React.createElement("div", { className: "input__area" },
                                            React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companionTxt, onChange: (e) => setCompanionTxt(e.target.value) }))))))),
        React.createElement("div", { className: "popup__footer" }, (companionTxt) ? // 반려 입력 시 활성화
            React.createElement("button", { type: "button", onClick: (e) => siteCompanion(e, list) },
                React.createElement("span", null, "\uC644\uB8CC"))
            :
                (siteDisplayDone) ? // 승인 선택 시 활성화
                    React.createElement("button", { type: "button", onClick: (e) => siteDone(e, list) },
                        React.createElement("span", null, "\uC644\uB8CC"))
                    :
                        React.createElement("button", { type: "button", disabled: true },
                            React.createElement("span", null, "\uC644\uB8CC")))));
}
